module.exports = __webpack_public_path__ + "static/sf_16.c8a2b055.png";